import { Component } from '@theme/component';

class CharacterJourneys extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.slots = [...this.querySelectorAll('[data-character-story-slot]')];
    this.launchers = [];
    this.targets = new Map();
    const stories = [...this.querySelectorAll('jv-journey')];
    const jv = document.querySelector('#jv-journey');
    if (jv) stories.unshift(jv);
    for (const story of stories) {
      const alt = story === jv ? this.dataset.jvProfileAlt : story.dataset.jvProfileAlt;
      const image = [...document.querySelectorAll('main img')].find(image => image.alt === alt);
      const card = image?.parentElement?.parentElement;
      const copy = card?.querySelector('[class$="-copy"]');
      if (!copy) continue;
      const key = story.dataset.jvCharacter || 'jv';
      const launcher = document.createElement('button');
      launcher.type = 'button';
      launcher.className = 'mc-story-launch';
      launcher.dataset.characterLaunch = key;
      launcher.setAttribute('aria-controls', story.id);
      launcher.setAttribute('aria-expanded', 'false');
      launcher.setAttribute('aria-label', `${this.dataset.storyOpenLabel}: ${card.querySelector('h3')?.textContent.trim() || key}`);
      launcher.textContent = `${this.dataset.storyOpenLabel} ↗`;
      const accent = story.style.getPropertyValue('--jv-gold');
      if (accent) launcher.style.setProperty('--story-accent', accent);
      copy.append(launcher);
      this.launchers.push(launcher);
      const slot = story.closest('[data-character-story-slot]');
      if (slot) card.parentElement.after(slot);
      this.targets.set(key, { story, slot, launcher });
    }
    document.addEventListener('click', this.onClick, { signal });
    document.addEventListener('toggle', this.onToggle, { signal, capture:true });
  }

  onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const launch = event.target.closest('[data-character-launch]');
    if (launch && this.launchers.includes(launch)) {
      this.open(launch.dataset.characterLaunch);
      return;
    }
    const returnButton = event.target.closest('[data-character-return]');
    if (returnButton && this.active?.story.contains(returnButton)) this.close(true);
  };

  onToggle = (event) => {
    if (event.target !== this.active?.story.querySelector('details')) return;
    if (!event.target.open) this.close(true);
  };

  open(key) {
    const target = this.targets.get(key);
    if (!target) return;
    if (this.active && this.active !== target) this.close(false);
    for (const other of this.targets.values()) {
      if (other !== target) other.story.querySelector('details').open = false;
    }
    this.active = target;
    if (target.slot) target.slot.hidden = false;
    target.launcher.setAttribute('aria-expanded', 'true');
    target.story.querySelector('details').open = true;
    target.story.scrollIntoView({ block:'start', behavior:'instant' });
    target.story.querySelector('[data-jv-scene] h2')?.focus({ preventScroll:true });
  }

  close(restoreFocus) {
    const active = this.active;
    if (!active) return;
    this.active = null;
    active.story.querySelector('details').open = false;
    if (active.slot) active.slot.hidden = true;
    active.launcher.setAttribute('aria-expanded', 'false');
    if (restoreFocus) active.launcher.focus();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.launchers?.forEach(button => button.remove());
    this.slots?.forEach(slot => { if (!this.contains(slot)) slot.remove(); });
    super.disconnectedCallback();
  }
}

if (!customElements.get('character-journeys')) customElements.define('character-journeys', CharacterJourneys);
